import { moscowCoords } from '../selectors/';
import { IApplicationState } from '../types/redux';
import { defaultFilterInitialState } from '../reducers/filter';
import { IResidentialComplex } from '../types/residentials';
import { defaultUser } from './user';

export const defaultHashState = { hash: {}, list: [] };

export const normalizedBanners = {
  list: [
    {
      id: 1,
      imageUrl: 'url1',
      label: 'label1',
      publicUrl: '/zhiloy-kompleks-salarevo-park-moskva-1/',
      jkId: 1,
      title: 'title1',
      hasCommercialProperty: true,
    },
    {
      id: 2,
      imageUrl: 'url2',
      label: 'label2',
      publicUrl: '/zhiloy-kompleks-salarevo-park-moskva-2/',
      jkId: 2,
      title: 'title',
      hasCommercialProperty: false,
    },
  ],
  hash: {
    1: {
      id: 1,
      imageUrl: 'url1',
      label: 'label1',
      publicUrl: '/zhiloy-kompleks-salarevo-park-moskva-1/',
      jkId: 1,
      title: 'title1',
      hasCommercialProperty: true,
    },
    2: {
      id: 2,
      imageUrl: 'url2',
      label: 'label2',
      publicUrl: '/zhiloy-kompleks-salarevo-park-moskva-2/',
      jkId: 2,
      title: 'title',
      hasCommercialProperty: false,
    },
  },
};

export const initialState: IApplicationState = {
  filter: defaultFilterInitialState,
  banners: normalizedBanners,
  locations: defaultHashState,
  residentialComplexes: defaultHashState,
  residentialComplexesIds: [],
  promos: {},
  common: {
    mapApiKey: '',
    subdomain: 'spb',
  },
  user: defaultUser,
  adfox: { puids: null },
  specialPromosBlocks: {
    banks: [],
    phone: '',
    mortgageBanner: null,
  },
};

export const residentialComplexes: IResidentialComplex[] = [
  {
    address: 'SPB',
    bankIds: [1, 2, 3],
    coordinates: moscowCoords,
    finishInfo: { years: null, label: 'Finish label' },
    hasDecoration: true,
    id: 1,
    imgUrl: '',
    maxArea: 300,
    maxPrice: 20000000,
    minArea: 50,
    minPrice: 11111,
    promoLabel: 'Sale 50%',
    publicUrl: '#',
    roomsInfo: null,
    title: 'Dream JK',
    undegroundInfo: { lineColor: 'FFFFFF', title: 'White branch' },
    useDecorationFilter: null,
  },
  {
    address: 'MSK',
    bankIds: [3, 4, 5],
    coordinates: moscowCoords,
    finishInfo: { years: null, label: 'Finish label' },
    hasDecoration: true,
    id: 2,
    imgUrl: '',
    maxArea: 400,
    maxPrice: 30000000,
    minArea: 60,
    minPrice: 21111,
    promoLabel: 'Sale 40%',
    publicUrl: '#',
    roomsInfo: null,
    title: 'Dream JK in Moscow',
    undegroundInfo: { lineColor: '000000', title: 'Black branch' },
    useDecorationFilter: null,
  },
];
export const normalizedResidentialComplexes = {
  list: residentialComplexes,
  hash: {
    [residentialComplexes[0].id]: residentialComplexes[0],
    [residentialComplexes[1].id]: residentialComplexes[1],
  },
};

export const residentialComplexesWithPikPlus: IResidentialComplex[] = [
  {
    ...residentialComplexes[0],
    displayType: 'plus',
    description: 'First description',
    equipmentOptions: [
      {
        title: "1 First equipment'",
        imageUrl: '1_first_url.png',
      },
      {
        title: "1 Second equipment'",
        imageUrl: '1_second_url.png',
      },
    ],
  },
  {
    ...residentialComplexes[1],
  },
];
export const normalizedResidentialComplexesWithPikPlus = {
  list: residentialComplexesWithPikPlus,
  hash: {
    [residentialComplexesWithPikPlus[0].id]: residentialComplexesWithPikPlus[0],
    [residentialComplexesWithPikPlus[1].id]: residentialComplexesWithPikPlus[1],
  },
};

export const locationCenterCoordinates = { center: moscowCoords, zoom: 11 };
